import { useEffect, useState } from "react";
import AddModal from "./AddModal";
import EditModal from "./EditModal";
import configurationAPI from "../../../apis/configuration/configurationAPI";
import Swal from "sweetalert2";

function HCCConfiguration({ selectedLoc, selectedClient }) {
    const [showAddHCCFieldModal, setShowAddHCCFieldModal] = useState(false);
    const [showEditHCCFieldModal, setShowEditHCCFieldModal] = useState(false);
    const [invalidateHCCFields, setInvalidateHCCFields] = useState(false);
    const [hccFields, setHCCFields] = useState([]);
    const [hccFieldEditData, setHCCFieldEditData] = useState({});
    const [isDeleting, setIsDeleting] = useState(null);

    const fetchHCCFields = async () => {
        try {
            const res = await configurationAPI.getHCCFields();
            if (res.success) {
                setHCCFields(res?.data);
            } else {
                window.toastr.error(res?.message);
            }
        } catch (error) {
            window.toastr.error(error?.message || "Couldn't fetch custom fields.");
        }
    };

    const handleDeleteHCCField = (id) => {
        if (!id) return;
        Swal.fire({
          text: `Do you want to delete selected item?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-sm btn-primary',
            cancelButton: 'btn btn-sm btn-secondary',
          },
        }).then(async (result) => {
          if (result?.value === true) {
            setIsDeleting(id);
            try {
              const res = await configurationAPI.deleteHCCField(id);
              if (res.success) {
                window.toastr.success(res?.message);
                setInvalidateHCCFields(prev => !prev);
              } else {
                window.toastr.error(res?.message);
              }
            }
            catch (error) {
              window.toastr.error(error?.message);
            }
          }
        });
        setIsDeleting(null);
    }

    useEffect(() => {
        let flag = true;
        if (flag) {
            fetchHCCFields();
        }
        return () => flag = false;

        // eslint-disable-next-line
    }, [invalidateHCCFields]);

    const handleOpenAddHCCFieldModal = () => setShowAddHCCFieldModal(true);
    const handleCloseAddHCCFieldModal = () => setShowAddHCCFieldModal(false);
    const handleOpenEditHCCFieldModal = (data) => {
        setShowEditHCCFieldModal(true);
        setHCCFieldEditData(data);
    }
    const handleCloseEditHCCFieldModal = () => setShowEditHCCFieldModal(false);

    return (
        <>
            <div className="d-flex flex-column gap-7 gap-lg-5">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-12">
                        <div className="card card-flush mb-4">
                            <div className="card-header">
                                <div className="card-title d-flex gap-4 justify-content-between">
                                    <h4>HCC Fields' Configuration</h4>
                                    <button
                                        onClick={handleOpenAddHCCFieldModal}
                                        type="button"
                                        aria-label="Add Field"
                                        className="btn btn-primary btn-sm"
                                    > <i className="fas fa-plus" /> Add Field
                                    </button>
                                </div>
                            </div>
                            <div className="card-body pt-0">
                                <div className="row justify-content-around align-items-start">
                                    <table className="col-6" cellSpacing={8} cellPadding={8}>
                                        <thead>
                                            <tr>
                                                <th>Custom Fields</th>
                                                <th>Type</th>
                                                <th>Is Multi-select</th>
                                                <th>Validation</th>
                                                <th>Preserve for next record</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                hccFields?.map((customField) => (
                                                    <tr key={customField.id}>
                                                        <td>{customField?.name}</td>
                                                        <td>{customField?.type}</td>
                                                        <td>{customField?.type !== 'dropdown' ? 'NA' : customField?.isMultiSelect ? 'Yes' : 'No'}</td>
                                                        <td>{customField?.validation}</td>
                                                        <td>{customField?.preserveOnNextRecord ? 'Yes' : 'No'}</td>
                                                        <td>
                                                            <div className="d-flex gap-2 justify-content-center align-items-center">
                                                                <button onClick={() => handleOpenEditHCCFieldModal(customField)} className="btn btn-sm"><i className="fa fa-edit" /></button>
                                                                <button onClick={() => handleDeleteHCCField(customField.id)} className="btn btn-sm"><i className="fa fa-trash" /></button>
                                                                {isDeleting === customField.id && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {
                (showAddHCCFieldModal) && (
                    <AddModal
                        onHide={handleCloseAddHCCFieldModal}
                        show={showAddHCCFieldModal}
                        setInvalidateHCCFields={setInvalidateHCCFields}
                    />
                )
            }
            {
                (showEditHCCFieldModal) && (
                    <EditModal
                        onHide={handleCloseEditHCCFieldModal}
                        show={showEditHCCFieldModal}
                        hccFieldsEditData={hccFieldEditData}
                        selectedLoc={selectedLoc}
                        setInvalidateHCCFields={setInvalidateHCCFields}
                    />
                )
            }
        </>
    )
}

export default HCCConfiguration